const convertStringToNumber = (inputString: string) => {
  const stringWithoutCommas = inputString.replace(/,/g, '');

  return parseFloat(stringWithoutCommas);
};

export default convertStringToNumber;
